import styled from 'styled-components';

export const Message = styled.h2`
  text-align: center;
  color: #3f51b5;
  font-size: 20px;
`;
